import { Injectable } from '@angular/core';
import { DwoAppointemntSubCheckListViewModel } from '../business-entities/dwo-sub-check-list-detail-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { DwoCheckListDataService } from '../data-services/dwo-checklist-data-service';
import { DWOCheckListRequestModel } from '../business-entities/dwo-sub-check-list-view-model';
@Injectable({
  providedIn: 'root'
})
export class DwoCheckListBusinessService {

  checkList: DwoAppointemntSubCheckListViewModel[];

  constructor(private checkListDataService: DwoCheckListDataService) { }

  getCheckList(param: DWOCheckListRequestModel): Promise<GenericResponse<Array<DwoAppointemntSubCheckListViewModel>>> {
    return this.checkListDataService.getCheckList(param);
  }
}
